import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { NewCampaignContainer } from "./new-campaign-style";
import InputBox from "../../../../components/input-box/input-box";
import CalendarBox from "../../../../components/calendar-box/calendar-box";
import DicotomicButton from "../../../../components/dicotomic-button";
import MainTable from "../../../../components/main-table";
import { PRODUCT_CARD_NAME_COLOR } from "../../../../constants/policyType";
import MainButton from "../../../../components/main-button";
import moment from "moment";
import NoteText from "../../../../components/components-text/note-text";
import CampaignsServices from "../../../../services/CampaignsServices";
import LeftInfoModal from "../../../../components/left-info-modal";
import { images } from "../../../../assets";
import GoBack from "../../../../components/go-back";
import ProductServices from "../../../../services/ProductServices";


interface ProductCampaign {
  colectivo: string;
  combinacion_comercial: string
}

interface Campaign {
  code: string;
  name: string;
  description: string;
  isRequired: boolean;
  startDate: string;
  endDate: string;
  startEffectDate: string;
  endEffectDate: string;
  products: ProductCampaign [];
}

interface CampaignProps extends RouteComponentProps {
  setLoading: Function;
}

interface CampaignState {
  isEdit: boolean;
  selectedTag: number;
  campaignProducts: any;
  campaign: Campaign;
  errors: { [key: string]: string };
  successfullyAction: boolean;
  showDeleteModal: boolean;
  successfullyDeleted: boolean;
  errorText: string;
}

const COLUMNS_SELECT_PRODUCTS = [
  {
    text: "ID",
    filter: false,
    ascendent: true,
  },
  {
    text: "PRODUCTO",
    filter: false,
    ascendent: true,
  },
  {
    text: "COLECTIVO",
    filter: false,
    ascendent: true,
    key: 'inline',
  },
  {
    text: "COMBINACIÓN COMERCIAL",
    filter: false,
    ascendent: false,
    key: 'inline',
  },
  {
    text: "SELECCIONADO",
    filter: false,
    ascendent: true,
    key: 'inline',
  },
];


class NewCampaign extends React.Component<CampaignProps, CampaignState> {
  constructor(props: CampaignProps) {
    super(props);

    this.state = {
      isEdit: this.props.match.path === "/gestor-campañas/editar/:code",
      selectedTag: 0,
      campaignProducts: undefined,
      campaign: {
        code: "",
        name: "",
        description: "",
        isRequired: false,
        startDate: "",
        endDate: "",
        startEffectDate: "",
        endEffectDate: "",
        products: [],
      },
      errors: {},
      successfullyAction: false,
      showDeleteModal: false,
      successfullyDeleted: false,
      errorText: ""
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    const { isEdit } = this.state;

    await this.getProducts();

    if (isEdit) {
      const {code}: any = match.params;
      if (code) this.getCampaignsByCode(code);
    }
  }

  async getProducts() {
    let allProducts: any;
    let productsByAreaName: any;

    try {
      const args = {
        loader: true,
        setLoading: () => { }
      };
      allProducts = await ProductServices.getActiveProducts(args);
      productsByAreaName = await ProductServices.getProductsByAreaName(args)
      if (Object.keys(allProducts).length === 0 || Object.keys(productsByAreaName).length === 0) this.props.history.push("/gestor-campañas");
    } catch (error) {
      console.log(error);
      this.props.history.push("/gestor-campañas");
    }

    let products: any = {};

    Object.keys(productsByAreaName).filter(area => area !== 'GIP').forEach( area => {
      products[area] = [];
      productsByAreaName[area].forEach((internalName: any) => {
        Object.keys(allProducts).forEach((p: any) => {
          const product = allProducts[p];

          if (product.products_internalName === internalName && product.products_colectivo != "00000") {
            products[area].push({
              id: product.products_id,
              name: product.products_name,
              cardName: product.products_cardName,
              colective: product.products_colectivo,
              combinacion_comercial: product.products_combinacion_comercial
            });
          }

        });
      });
    });
    this.setState({ campaignProducts: products });
  }

  async getCampaignsByCode (code: string) {
    try {
      const { setLoading } = this.props;
      const campaignsByCode = await CampaignsServices.getCampaignsByCode({
        code,
        loader: true,
        setLoading,
      });
      
      if (Array.isArray(campaignsByCode) && campaignsByCode.length>0) {
        const campaign: Campaign = {
          code: campaignsByCode[0].code,
          name: campaignsByCode[0].name,
          description: campaignsByCode[0].description,
          isRequired: campaignsByCode[0].isRequired,
          startDate: moment(campaignsByCode[0].startDate).format("DD/MM/YYYY"),
          endDate: moment(campaignsByCode[0].endDate).format("DD/MM/YYYY"),
          startEffectDate: moment(campaignsByCode[0].startEffectDate).format("DD/MM/YYYY"),
          endEffectDate: moment(campaignsByCode[0].endEffectDate).format("DD/MM/YYYY"),
          products: campaignsByCode.map((c: any) => { return { colectivo: c.colectivo, combinacion_comercial: c.combinacion_comercial} })
        }
        this.setState({ campaign });
      }
      else this.props.history.push("/gestor-campañas");
    } catch (error) {
      this.props.history.push("/gestor-campañas");
    }
  }

  handleChangeTab = (tag: number) => this.setState({ selectedTag: tag });

  formatRows() {
    const {campaign, campaignProducts, selectedTag} = this.state;
    const area = Object.keys(campaignProducts)[selectedTag];
    const rows = campaignProducts[area].map((c : any) => {
      return {
        id: {
          text: c.id,
          type: "",
          key: "inline",
        },
        name: {
          text: c.name,
          type: PRODUCT_CARD_NAME_COLOR[c.cardName],
          key: "tag-container",
        },
        colectivo: {
          text: c.colective,
          type: "",
          key: "inline",
        },
        combinacion_comercial: {
          text: c.combinacion_comercial,
          type: "",
          key: "inline",
        },
        isSelected: {
          text: this.isSelectedProduct(c.colective, c.combinacion_comercial) ? "SI" : "NO",
          type: "",
          key: "checkbox",
          value: this.isSelectedProduct(c.colective, c.combinacion_comercial),
          onClick: (value : any) => {
            if (value === "NO") campaign.products.push({colectivo: c.colective, combinacion_comercial: c.combinacion_comercial});
            else campaign.products = campaign.products.filter((p: any) => p.colectivo !== c.colective || p.combinacion_comercial !== c.combinacion_comercial);
            this.setState({campaign});
          },
        },
      }
    });

    return rows;
  }

  isSelectedProduct (colective: string, comb_comercial: string) {
    const {campaign} = this.state;
    return campaign.products.find((p: any) => p.colectivo === colective && p.combinacion_comercial === comb_comercial);
  }

  changeValue( value: any, key: string ) {
    const { campaign } = this.state;
    campaign[key as keyof Campaign] = value;
    this.setState({campaign});
  }

  validateForm () { 
    const { campaign } = this.state;
    const errors: { [key: string]: string } = {};
    let isCorrect = true;

    if (this.toMoment(campaign.startDate).isSameOrAfter(this.toMoment(campaign.endDate))) {
      errors.startDate = "invalid-first-date";
      errors.endDate = "invalid-second-date";
      isCorrect = false;
    }
    if (this.toMoment(campaign.startEffectDate).isSameOrAfter(this.toMoment(campaign.endEffectDate))) {
      errors.startEffectDate = "invalid-first-date";
      errors.endEffectDate = "invalid-second-date";
      isCorrect = false;
    }
    if (this.toMoment(campaign.startDate).isAfter(this.toMoment(campaign.startEffectDate))) {
      errors.startEffectDate = "invalid-first-effect-date";
      isCorrect = false;
    }
    if (this.toMoment(campaign.endDate).isBefore(this.toMoment(campaign.endEffectDate))) {
      errors.endEffectDate = "invalid-second-effect-date";
      isCorrect = false;
    }

    Object.entries(campaign).forEach(entry => {
      const field = entry[0];
      const value = entry[1];
      if ((typeof value === "string" && (!value || value === "")) || (Array.isArray(value) && value.length === 0)) {
        errors[field] = "required";
        isCorrect = false;
      }  
    });

    this.setState({ errors }, () => {
      if (isCorrect) this.saveCampaign();
    });
  }

  toMoment(date: string) {
    return moment(date, 'DD/MM/YYYY');
  }

  async saveCampaign () {
    const { setLoading } = this.props;
    const { campaign, isEdit } = this.state;
    
    try {
      const args = { campaign, loader: true, setLoading };
      isEdit ? await CampaignsServices.updateCampaign(args) : await CampaignsServices.addCampaign(args);
      this.setState({ successfullyAction: true });
    } catch (error) {
      console.log(error)
      if (error && error.data && error.data.message) this.setState({ errorText: error.data.message });
    }
  }

  async deleteCampaign () {
    const { setLoading } = this.props;
    const { campaign } = this.state;
    
    try {
      await CampaignsServices.deleteCampaignsByCode({
        code: campaign.code,
        loader: true,
        setLoading,
      });
      this.setState({ successfullyDeleted: true });
    } catch (error) {
      this.setState({ errorText: `Se ha producido un error eliminando la información de la campaña con código ${campaign.code}.` });
    }
  }

  render() {
    const { campaign, errors, selectedTag, campaignProducts, isEdit, showDeleteModal, successfullyAction, successfullyDeleted, errorText } = this.state;

    return (
      <NewCampaignContainer>
        <div className="bottomMargin10">
          <GoBack />
        </div>
        
        <div className="main-title-container-complex">
          <div className="main-title-container-complex-item col-6">
            <h2 className="campaings-title">{isEdit ? "Editar campaña" :"Nueva campaña"}</h2>
          </div>
          <div className="col-6">
            <MainButton text="GUARDAR CAMPAÑA" onClick={() => this.validateForm() } />
          </div>
          { isEdit && 
            <div className="col-6 leftMargin30">
              <MainButton text="ELIMINAR CAMPAÑA" type="red" onClick={() => this.setState({ showDeleteModal: true })} />
            </div>
          }
        </div>
        
        <div className="campaign-data-row">
          <div className="campaign-data-item col-50">
            <div className="inputBox">
              <InputBox
                placeholder="Código"
                required={true}
                disabled={isEdit}
                value={campaign.code}
                onChange={(value: string) => this.changeValue(value.toUpperCase(), "code")}
                type={"numbersletter"}
                errorCode={errors.code}
              />
            </div>
          </div>

          <div className="campaign-data-item col-50">
            <div className="inputBox">
            <InputBox
                placeholder="Nombre"
                required={true}
                disabled={false}
                value={campaign.name}
                onChange={(value: string) => this.changeValue(value.toUpperCase(), "name")}
                errorCode={errors.name}
              />
            </div>
          </div>
        </div>
        
        <div className="campaign-data-row">
          <div className="campaign-data-item col-50">
            <div className="inputBox">
              <InputBox
                placeholder="Descripción"
                required={true}
                disabled={false}
                value={campaign.description}
                onChange={(value: string) => this.changeValue(value.toUpperCase(), "description")}
                errorCode={errors.description}
              />
            </div>
          </div>

          <div className="campaign-data-item col-50">
            <div className="inputBox dicotomic">
               <DicotomicButton
                  labelText="¿Campaña obligatoria?"
                  withTab={true}
                  options={[
                    { code: "Y", label: "Si" },
                    { code: "N", label: "No" }
                  ]}
                  initialValue={campaign.isRequired? "Y" : "N"}
                  disabled={false}
                  onChange={(value: string) => this.changeValue(value === "Y", "isRequired")}
                  errorCode={errors.isRequired}
                />
            </div>
          </div>
        </div>

        <div className="campaign-data-row">
          <div className="campaign-data-item col-50">
            <div className="inputBox">
              <CalendarBox
                initialValue={campaign.startDate}
                placeholder="Fecha inicio de aplicación"
                required={true}
                disabled={false}
                onChange={(value: string) => this.changeValue(value, "startDate")}
                errorCode={errors.startDate}
              />
            </div>
          </div>

          <div className="campaign-data-item col-50">
            <div className="inputBox">
              <CalendarBox
                initialValue={campaign.endDate}
                placeholder="Fecha fin de aplicación"
                required={true}
                disabled={false}
                onChange={(value: string) => this.changeValue(value, "endDate")}
                errorCode={errors.endDate}
              />
            </div>
          </div>
        </div>

        <div className="campaign-data-row">
          <div className="campaign-data-item col-50">
            <div className="inputBox">
              <CalendarBox
                initialValue={campaign.startEffectDate}
                placeholder="Fecha inicio de efecto"
                required={true}
                disabled={false}
                onChange={(value: string) => this.changeValue(value, "startEffectDate")}
                errorCode={errors.startEffectDate}
              />
            </div>
          </div>

          <div className="campaign-data-item col-50">
            <div className="inputBox">
              <CalendarBox
                initialValue={campaign.endEffectDate}
                placeholder="Fecha fin de efecto"
                required={true}
                disabled={false}
                onChange={(value: string) => this.changeValue(value, "endEffectDate")}
                errorCode={errors.endEffectDate}
              />
            </div>
          </div>
        </div>

        { campaignProducts &&
          <>
            <div className="campaign-products topMargin40 bottomMargin20">
              <h5>Selección de productos:</h5>
              {errors.products && (
                <div className="input-box-error">
                  <NoteText>
                    <p>{`* Debe seleccionar al menos un producto`}</p>
                  </NoteText>
                </div>
              )}
            </div>
        
            <div className="product-filter-container">
              <div className="tabs-container">
                <div className="tabs-container__tabs">
                  { Object.keys(campaignProducts).map((area, index) => {
                    return <div key={index} className={selectedTag === index ? "selected" : ""} onClick={() => this.handleChangeTab(index)}>{area}</div>
                  })}
                </div>
              </div>

              <div className="topMargin40">
                <MainTable
                  className="table"
                  columns={COLUMNS_SELECT_PRODUCTS}
                  rows={this.formatRows()}
                  keysRow={["id", "name", "colectivo", "combinacion_comercial", "isSelected"]}
                />
              </div>  
            </div>
          </>
        }

        { showDeleteModal && (
          <LeftInfoModal
            img={images.IconWarningYellow}
            className="warning"
            mainTitle={"¿Seguro que desea continuar?"}
            mainText={`Se eliminará toda la información asociada a la campaña ${campaign.code}.`}
            buttonText="Eliminar"
            closeButtonText="Cancelar"
            close={() => this.setState({ showDeleteModal: false })}
            active={true}
            onClickAccept={() => { this.deleteCampaign() }}
          />
        )}

        { successfullyDeleted && (
          <LeftInfoModal
            img={images.IconWarningYellow}
            className="info"
            mainTitle={"Eliminación realizada"}
            mainText={`Se ha eliminado toda la información asociada a la campaña ${campaign.code}.`}
            buttonText="Aceptar"
            noSecondaryButton={true}
            close={() => this.props.history.push("/gestor-campañas")}
            active={true}
            onClickAccept={() => this.props.history.push("/gestor-campañas") }
          />
        )}

        { successfullyAction && (
          <LeftInfoModal
            img={images.IconWarningYellow}
            className="info"
            mainTitle={`${isEdit ? 'Actualización' : 'Inserción'} realizada`}
            mainText={`Se ha ${isEdit ? 'actualizado' : 'insertado'} la información asociada a la campaña ${campaign.code}.`}
            buttonText="Aceptar"
            noSecondaryButton={true}
            close={() => this.props.history.push("/gestor-campañas")}
            active={true}
            onClickAccept={() => this.props.history.push("/gestor-campañas") }
          />
        )}

        { errorText && (
          <LeftInfoModal
            img={images.IconWarningYellow}
            className="error"
            mainTitle={"Se ha producido un error"}
            mainText={`${errorText}`}
            buttonText="Aceptar"
            noSecondaryButton={true}
            close={() => this.setState({ errorText: "" })}
            active={true}
            onClickAccept={() => this.setState({ errorText: "" }) }
          />
        )}
      </NewCampaignContainer>
    );
  }
}

export default withRouter(NewCampaign);
